import { render, staticRenderFns } from "./VideoBase.vue?vue&type=template&id=dfa76e64&lang=pug"
import script from "./VideoBase.vue?vue&type=script&lang=ts"
export * from "./VideoBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports